import type {
  NatalieEventDetail,
  NatalieEventDetailData,
  NatalieEventPublicDetail,
  NatalieEventPublicDetailData,
} from './natalieEvent.types';

export const mapNataliePublicEventDetailFromApi = ({
  id,
  communityId,
  endDate,
  name,
  topic,
  description,
  ownerName,
  communityName,
  status,
  logoImageLink,
  videoUrl,
  sessionDurationMinutes,
}: NatalieEventPublicDetailData): NatalieEventPublicDetail => ({
  id,
  communityId,
  endDate,
  name,
  topic,
  description,
  ownerName,
  communityName,
  status,
  logoImageLink,
  videoUrl,
  durationInMinutes: sessionDurationMinutes,
});

export const mapNatalieEventDetailFromApi = ({
  id,
  communityId,
  endDate,
  name,
  topic,
  description,
  ownerName,
  communityName,
  status,
  sessionDurationMinutes,
  videoUrl,
}: NatalieEventDetailData): NatalieEventDetail => ({
  id,
  communityId,
  endDate,
  name,
  topic,
  description,
  ownerName,
  communityName,
  status,
  durationInMinutes: sessionDurationMinutes,
  videoUrl,
});
